import PosthogService from '~/services/posthog/PosthogService';
import {
  buildNotificationPreferenceProperties,
  type INotificationSettingRecord,
  type TOfferedChannelsByEvent,
} from '~/domain/NotificationSettings';

export interface INotificationSettingsCompletedPayload {
  /** Settings the API accepted. */
  settings: INotificationSettingRecord[];
  /** Channels each notification type actually offers, from `notificationTypeMap`. */
  offeredChannelsByEvent: TOfferedChannelsByEvent;
}

/**
 * Fires when a save succeeds, carrying the configuration that was persisted.
 * This is the only event that reflects saved state — `notification_toggled`
 * describes an attempt, which the office may never save.
 */
export function fireNotificationSettingsCompleted({
  settings,
  offeredChannelsByEvent,
}: INotificationSettingsCompletedPayload): void {
  PosthogService.getInstance().track(
    'dental_portal:notification_settings:settings_completed',
    buildNotificationPreferenceProperties(settings, offeredChannelsByEvent),
  );
}
